/**
 *
 * @param {String} name the current page name passed from router
 * @param {String} query router queries
 * @return {String} formatted page name
 */
const pageName = (name, query) => {
  let formattedName = name.replace(/-/g, ' ').replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());

  // Verify Info Read/Edit should return 'Verify Information' instead
  if (formattedName === 'Verify Info Read' || formattedName === 'Verify Info Edit') {
    formattedName = 'Verify Information';
  }

  // update the MCOA page event name
  if (query?.mcoa) {
    formattedName = 'Confirm Order MCOA';
  }

  return formattedName;
};


export default pageName;
